import { createFileRoute } from "@tanstack/react-router";
import { LoginPage } from "../features/auth/LoginPage";
import { useSession } from "../features/auth/session";
import { FullScreenSpinner } from "../features/shell/FullScreenSpinner";
import { Redirect } from "../features/shell/Redirect";

export const Route = createFileRoute("/login")({
  validateSearch: (s: Record<string, unknown>): { next?: string; add?: string } => ({
    ...(typeof s.next === "string" && s.next.startsWith("/") ? { next: s.next } : {}),
    // `add` means "sign in as somebody else as well", so an already-signed-in device must stay on
    // this page instead of being bounced home as though it had nothing to do here.
    ...(s.add === "1" ? { add: "1" } : {}),
  }),
  component: Login,
});

function Login() {
  const session = useSession();
  const { next, add } = Route.useSearch();
  if (session.status === "loading") return <FullScreenSpinner />;
  if (session.status === "authed" && !add)
    return next ? <Redirect href={next} replace /> : <Redirect to="/" replace />;
  return <LoginPage next={next} adding={add === "1"} />;
}
